import api from './config';

export const regaliaPascualAPI = {
  getAll: (companyId) =>
    api.get('/regalia-pascual', { params: { companyId } }).then(r => r.data),

  create: (data) =>
    api.post('/regalia-pascual', data).then(r => r.data),

  getById: (id) =>
    api.get(`/regalia-pascual/${id}`).then(r => r.data),

  calcular: (id) =>
    api.post(`/regalia-pascual/${id}/calcular`).then(r => r.data),

  getRecords: (id, params = {}) =>
    api.get(`/regalia-pascual/${id}/records`, { params }).then(r => r.data),

  getRecordDetalle: (id, recordId) =>
    api.get(`/regalia-pascual/${id}/records/${recordId}`).then(r => r.data),

  ajustarMonto: (id, recordId, data) =>
    api.put(`/regalia-pascual/${id}/records/${recordId}`, data).then(r => r.data),

  aprobar: (id) =>
    api.post(`/regalia-pascual/${id}/aprobar`).then(r => r.data),

  pagar: (id) =>
    api.post(`/regalia-pascual/${id}/pagar`).then(r => r.data),

  cancelar: (id) =>
    api.post(`/regalia-pascual/${id}/cancelar`).then(r => r.data),

  getReporte: (id) =>
    api.get(`/regalia-pascual/${id}/reporte`).then(r => r.data),

  downloadPayslip: (id, recordId) =>
    api.get(`/regalia-pascual/${id}/records/${recordId}/payslip`, {
      responseType: 'blob',
    }).then(r => r.data),
};
